module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block main-block-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-articles bck-views"
  }, [_c('h2', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(this.songView.title))]), _vm._v(" "), (!this.authorized) ? _c('span', {
    staticClass: "addtofav",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#loginpanel",
      "title": "會員登入"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("收藏")])]) : _vm._e(), _vm._v(" "), (this.authorized) ? _c('span', {
    staticClass: "addtofav",
    class: _vm.favoriteData,
    on: {
      "click": _vm.addToFavorite
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("收藏")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("by " + _vm._s(this.songView.author))])]), _vm._v(" "), _c('article', {
    staticClass: "article-editor",
    domProps: {
      "innerHTML": _vm._s(this.songView.context)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/songCategory/' + _vm.songView.category_id
    }
  }, [_c('span', {
    staticClass: "badge badge-primary"
  }, [_vm._v(_vm._s(_vm.songView.category_name))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items articles-songview"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg col-sm-6 push-sm-6"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg col-sm-6 pull-sm-6"
  }, [_c('article', {
    staticClass: "article-editor article-lyrics",
    domProps: {
      "innerHTML": _vm._s(_vm.songView.lyric)
    }
  })])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": 'https://www.weddingsung.com/songs/' + this.$route.params.id,
      "data-layout": "standard",
      "data-action": "like",
      "data-size": "small",
      "data-show-faces": "true",
      "data-share": "true"
    }
  }), _vm._v(" "), _c('Fbcomment', {
    attrs: {
      "videoId": this.$route.params.id
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.share), function(row, index) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "articles-box videoshare-box"
    }, [_c('div', {
      staticClass: "embed-responsive embed-responsive-16by9"
    }, [_c('iframe', {
      staticClass: "embed-responsive-item",
      attrs: {
        "src": row.link
      }
    })]), _vm._v(" "), _c('blockquote', {
      staticClass: "blockquote article-blockquote"
    }, [_c('h6', {
      staticClass: "title mb-0 text-primary"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('footer', {
      staticClass: "blockquote-footer"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor"
    }, [_c('p', {
      staticClass: "txt"
    }, [_vm._v("\n                                                " + _vm._s(_vm._f("doubledot")(_vm._f("truncate")(row.context, 250))) + "\n                                              ")])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "articles-box contact-box songshare-box"
  }, [_c('div', {
    staticClass: "text text-bg"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 offset-lg-3 col-md-8 offset-md-2"
  }, [_c('form', {
    staticClass: "contact-form songshare-form",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: " col-form-label-sm",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: " col-form-label-sm",
    attrs: {
      "for": "videolink"
    }
  }, [_vm._v("影片連結")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.link),
      expression: "link"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.link = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: " col-form-label-sm",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("分享內容")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.context),
      expression: "context"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "id": "message",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.context)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.context = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.shareSong
    }
  }, [_vm._v("送出")])])])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title title-bg-music"
  }, [_c('span', [_vm._v("推薦歌曲 - 歌詞與video")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v("歌曲使用分享")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "title text-primary text-center"
  }, [_vm._v("\n                                        如果你在婚禮上也使用過這首歌，"), _c('br'), _vm._v("歡迎上傳這首歌的婚禮 video\n                                      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c066182","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SongsView.vue
// module id = 157
// module chunks = 1